import {useMutation} from '@tanstack/react-query';
import {useContext} from 'react';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {Fetch} from '../../../envisia/workflow/models/fetch.models';
import {ErpAlertContext} from '../../components/react-angular-alert/erp-react-alert-context';

interface Props {
  workflowId: number;
  fetchId: number;
  successCallback: (status: number) => void;
}

export function useFetchStatusChangeMutation({workflowId, fetchId, successCallback}: Props) {
  const alertContext = useContext(ErpAlertContext);
  const {mutate, isPending} = useMutation({
    mutationFn: (status: number) =>
      AxiosHttpClient.put<Fetch>(
        `${environment.apiv4uri}workflow/${workflowId}/fetch/${fetchId}/status`,
        {status: status},
      ),
    onSuccess: (_fetch, status) => {
      alertContext.context.add('success', 'Status geändert!');
      successCallback(status);
    },
    onError: () => {
      alertContext.context.add('danger', 'Beim ändern des Status ist ein Fehler aufgetreten!');
    },
  });

  return {
    isPending,
    mutateFetchStatus: (status: number) => mutate(status),
  };
}
